import { render } from "./Create-or-edit-promo-template.vue?vue&type=template&id=5b475836&scoped=true"
import script from "./Create-or-edit-promo-template.vue?vue&type=script&lang=js"
export * from "./Create-or-edit-promo-template.vue?vue&type=script&lang=js"

import "./Create-or-edit-promo-template.vue?vue&type=style&index=0&id=5b475836&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b475836"]])

export default __exports__